
<div class="modal-header" *ngIf="options.title">{{options.title}}</div>
<div class="modal-body">
  <div *ngIf="options.progress">
    <spinner></spinner>
  </div>
  <div *ngIf="!options.danger &amp;&amp; options.text">{{options.text}}</div>
  <div class="d-flex align-items-center" *ngIf="options.danger &amp;&amp; options.text"><i class="fal fa-2x fa-exclamation-triangle mr-4 mt-1 text-danger"></i>
    <div>{{options.text}}</div>
  </div>
  <div *ngIf="options.prompt">
    <label>{{options.prompt}}</label>
    <input class="form-control" [type]="options.inputType" [(ngModel)]="options.value" data-test-qa="positiveInput" autofocus preselect id="messageboxModal-input">
  </div>
</div>
<div class="modal-footer">
  <button class="positive btn btn-outline-{{options.danger ? 'danger' : 'primary'}}" [disabled]="options.prompt &amp;&amp; !options.value?.trim()" (click)="tryPositive()" *ngIf="options.positive" data-test-qa="doPositive">{{options.positive}}</button>
  <button class="negative btn btn-outline-secondary" (click)="doNegative()" *ngIf="options.negative" data-test-qa="doNegative">{{options.negative}}</button>
</div>